import { DEFAULT_RESOURCE_QTY } from "components/Checkout/program/step/types/checkout.consts";

/**
 * Calculates the quantity of a product based on the number of resources and the product quantity.
 * @param productQuantity The quantity of the product.
 * @param resourcesQuantity The number of resources.
 * @returns The quantity of the product.
 */
export function calculateProductQuantity(productQuantity: number, resourcesQuantity?: number): number {
	return Math.ceil((resourcesQuantity || DEFAULT_RESOURCE_QTY) / (productQuantity || DEFAULT_RESOURCE_QTY));
}
